var map = {
	"./Banner.gif": 3619,
	"./aids.png": 3652,
	"./capsule.png": 3705,
	"./cursor.png": 1867,
	"./cursor_magazine.pdf": 9949,
	"./dw_chai.jpg": 8765,
	"./dw_festive.jpg": 3246,
	"./dw_festive1.jpg": 5686,
	"./dw_graph.png": 2936,
	"./hemp.png": 7920,
	"./hemp_1.png": 4064,
	"./hemp_2.png": 9010,
	"./lgbtq.png": 3775,
	"./medium.png": 8444,
	"./nectar.png": 3633,
	"./nectar_1.png": 793,
	"./nectar_2.png": 3584,
	"./omni.pdf": 2550,
	"./rnb.jpg": 4874,
	"./soundcloud.pdf": 1254,
	"./soundcloud.png": 3805,
	"./tagline.png": 78,
	"./techabled.png": 7575,
	"./underaman.png": 644,
	"./ww_ad.png": 7137,
	"./ww_carousel.png": 6916,
	"./ww_carousel_1.png": 7967,
	"./ww_post.png": 7207,
	"./ww_post1.png": 1586
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2668;